import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';

import CheckMarkedContainer from '@/components/common/CheckMarkedContainer';
import CheckMarkedElement from '@/components/common/CheckMarkedElement';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

const RadioElement = ({ nbElements, option, name, isRequired }) => {
  const { register, watch, setValue } = useFormContext();
  const watchValue = watch(name);
  const isTabletOrAbove = useScreenSizeContext().isTablet;
  const colsToDisplay = isTabletOrAbove ? Math.floor(12 / nbElements) : '12 mb-3';

  const handleSelect = () => {
    setValue(name, option.value);
  };

  return (
    <div className={`col-${colsToDisplay}`}>
      <CheckMarkedContainer
        selected={option.value === watchValue}
        onSelect={handleSelect}
        {...register(name, { required: isRequired })}
      >
        <CheckMarkedElement>
          <span className="w-100 text-center" data-rbf={`checkbox-${option.value}`}>{option.label}</span>
        </CheckMarkedElement>
      </CheckMarkedContainer>
    </div>
  );
};

RadioElement.propTypes = {
  nbElements: PropTypes.number.isRequired,
  option: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any
  }).isRequired,
  name: PropTypes.string.isRequired,
  isRequired: PropTypes.bool
};

export default RadioElement;
